import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Herrer.jpg'
import _imports_1 from '@/assets/img/Damer.jpg'
import _imports_2 from '@/assets/img/Drenge.jpg'
import _imports_3 from '@/assets/img/Piger.jpg'
import _imports_4 from '@/assets/img/Paradart.jpg'


const _withScopeId = n => (_pushScopeId("data-v-7f74aff5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rangliste" }
const _hoisted_2 = { class: "display-2 mb-4 capitalize textcenter" }
const _hoisted_3 = { class: "va-table-responsive row" }
const _hoisted_4 = { class: "row justify--end" }
const _hoisted_5 = { class: "flex md12 va-table va-table--clickable va-table--hoverable rankingTable" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Nr."),
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", null, "Klub"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Points"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "abPlayer center"
}, "A-spillere", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "abPlayer center"
}, "B-Spillere", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "center" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "center" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { class: "center" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "layout gutter--xl" }
const _hoisted_35 = { class: "row justify--space-around" }
const _hoisted_36 = { class: "flex md2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "200"
  })
], -1))
const _hoisted_38 = { class: "flex md2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "200"
  })
], -1))
const _hoisted_40 = { class: "flex md2" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    width: "200"
  })
], -1))
const _hoisted_42 = { class: "flex md2" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    width: "200"
  })
], -1))
const _hoisted_44 = { class: "flex md2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ranghover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    width: "200"
  })
], -1))
const _hoisted_46 = { class: "display-6 mb-2 textcenter" }
const _hoisted_47 = { class: "va-table-responsive row" }
const _hoisted_48 = { class: "flex md12 va-table va-table--clickable va-table--hoverable rankingTable" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Stævne"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Dato"),
    /*#__PURE__*/_createElementVNode("th", null, "Række"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Placering"),
    /*#__PURE__*/_createElementVNode("th", { class: "textcenter" }, "Point")
  ])
], -1))
const _hoisted_50 = { class: "center" }
const _hoisted_51 = { class: "center" }
const _hoisted_52 = { class: "center" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  style: {"text-align":"right"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Total:")
], -1))
const _hoisted_54 = { class: "center" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("Luk")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_select = _resolveComponent("va-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, "Rangliste, " + _toDisplayString(_ctx.ranking), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_va_select, {
          modelValue: _ctx.selectedResultor,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedResultor) = $event)),
          class: "mb-3",
          options: _ctx.resultorOptions,
          "text-by": (option) => option.title,
          "track-by": (resultorOptions) => resultorOptions.value,
          label: "Rangliste"
        }, null, 8, ["modelValue", "options", "text-by", "track-by"])
      ]),
      _createElementVNode("table", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("tbody", null, [
          (_ctx.ranking !== 'paradart')
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aPlayersRanked, (player, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: _normalizeClass({ nolicens: !player.activeLicense })
            }, [
              _createElementVNode("td", _hoisted_10, _toDisplayString(index + 1), 1),
              (player.memberId !== null)
                ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      to: { name: 'Memberinfo', params: { slug: _ctx.createMemberSlug(player.memberId, player.memberName)}, }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(player.memberName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(player.memberName), 1)),
              (player.clubId !== null)
                ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      to: {name: 'theClub', params: { slug: player.clubSlug}, }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(player.clubName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(player.clubName), 1)),
              _createElementVNode("td", null, _toDisplayString(player.total), 1),
              _createElementVNode("td", _hoisted_15, [
                _createElementVNode("p", {
                  class: "clickAble",
                  onClick: ($event: any) => (_ctx.memberResultsDetails(player.memberId, player.license, player.memberName, player.clubName))
                }, "Resultater", 8, _hoisted_16)
              ])
            ], 2))
          }), 128)),
          (_ctx.bPlayersRanked.length >= 1 && _ctx.ranking !== 'paradart')
            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bPlayersRanked, (player, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: _normalizeClass({ nolicens: !player.activeLicense })
            }, [
              _createElementVNode("td", _hoisted_20, _toDisplayString(index + 1 + _ctx.aPlayersRanked.length), 1),
              (player.memberId !== null)
                ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                    _createVNode(_component_router_link, {
                      to: { name: 'Memberinfo', params: { slug: _ctx.createMemberSlug(player.memberId, player.memberName)}, }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(player.memberName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(player.memberName), 1)),
              (player.clubId !== null)
                ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                    _createVNode(_component_router_link, {
                      to: {name: 'theClub', params: { slug: player.clubSlug}, }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(player.clubName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_24, _toDisplayString(player.clubName), 1)),
              _createElementVNode("td", null, _toDisplayString(player.total), 1),
              _createElementVNode("td", _hoisted_25, [
                _createElementVNode("p", {
                  class: "clickAble",
                  onClick: ($event: any) => (_ctx.memberResultsDetails(player.memberId, player.license, player.memberName, player.clubName))
                }, "Resultater", 8, _hoisted_26)
              ])
            ], 2))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cPlayersRanked, (player, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: _normalizeClass({ nolicens: !player.activeLicense })
            }, [
              _createElementVNode("td", _hoisted_27, _toDisplayString(index + 1 + _ctx.aPlayersRanked.length + _ctx.bPlayersRanked.length), 1),
              (player.memberId !== null)
                ? (_openBlock(), _createElementBlock("td", _hoisted_28, [
                    _createVNode(_component_router_link, {
                      to: { name: 'Memberinfo', params: { slug: _ctx.createMemberSlug(player.memberId, player.memberName)}, }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(player.memberName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(player.memberName), 1)),
              (player.clubId !== null)
                ? (_openBlock(), _createElementBlock("td", _hoisted_30, [
                    _createVNode(_component_router_link, {
                      to: {name: 'theClub', params: { slug: player.clubSlug}, }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(player.clubName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_31, _toDisplayString(player.clubName), 1)),
              _createElementVNode("td", null, _toDisplayString(player.total), 1),
              _createElementVNode("td", _hoisted_32, [
                _createElementVNode("p", {
                  class: "clickAble",
                  onClick: ($event: any) => (_ctx.memberResultsDetails(player.memberId, player.license, player.memberName, player.clubName))
                }, "Resultater", 8, _hoisted_33)
              ])
            ], 2))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'herrer' },} }, {
            default: _withCtx(() => [
              _hoisted_37
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'damer' },} }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'drenge' },} }, {
            default: _withCtx(() => [
              _hoisted_41
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'piger' },} }, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_router_link, { to: {name: 'Rankinglist', params: { rankingSlug: 'paradart' },} }, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.memberResultsModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.memberResultsModal) = $event)),
      size: "large",
      "overlay-opacity": "0.5",
      "hide-default-actions": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          class: "btn",
          color: "success",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.memberResultsModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_55
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("h6", _hoisted_46, _toDisplayString(_ctx.memberDetails.name) + " for " + _toDisplayString(_ctx.memberDetails.clubName), 1),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("table", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankingDetails, (result, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass({ italic: result.rowName === 'C-rækken'})
                }, [
                  _createElementVNode("td", null, _toDisplayString(result.competitionName), 1),
                  _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.toDanishDateString(result.date)), 1),
                  _createElementVNode("td", null, _toDisplayString(result.rowName + (result.rowName === 'C-rækken' ? ', ' + _ctx.displayGender(result.genderId) : '')), 1),
                  _createElementVNode("td", _hoisted_51, _toDisplayString(result.placement), 1),
                  _createElementVNode("td", _hoisted_52, _toDisplayString((result.rowName === 'C-rækken' && _ctx.displayGender(result.genderId) !== _ctx.ranking ? 0 : result.points)), 1)
                ], 2))
              }), 128)),
              _createElementVNode("tr", null, [
                _hoisted_53,
                _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.calcDetailsTotal(_ctx.rankingDetails)), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}